import ModalDev from './_modal_dev'
import AccordionGrid from './accordion-grid'
import AdvertisementGrid from './advertisement-grid'
import Banner from './banner'
import BannerSlider from './banner-slider'
import Cards from './cards'
import FAQ from './faq'
import Form from './form'
import Gallery from './gallery'
import Hero from './hero'
import LocationGrid from './location-grid'
import Media from './media'
import MediaSlider from './media-slider'
import NewsGrid from './news-grid'
import Numbers from './numbers'
import Paragraph from './paragraph'
import PricingGrid from './pricing-grid'
import Proposals from './proposals'
import Row from './row'
import SearchGrid from './search-grid'
import Spacer from './spacer'
import StudentRequests from './student-requests'
import SupportoAssistenza from './supporto-assistenza'
import Table from './table'
import TabsHeading from './tabs-heading'
import Tape from './tape'

export const sectionsMap: any = {
  _modal_dev: ModalDev,
  accordion_grid: AccordionGrid,
  advertisement_grid: AdvertisementGrid,
  banner: Banner,
  banner_slider: BannerSlider,
  faq: FAQ,
  form: Form,
  gallery: Gallery,
  hero: Hero,
  location_grid: LocationGrid,
  cards: Cards,
  media: Media,
  media_slider: MediaSlider,
  news: NewsGrid,
  numbers: Numbers,
  paragraph: Paragraph,
  pricing_grid: PricingGrid,
  proposals: Proposals,
  row: Row,
  search_grid: SearchGrid,
  spacer: Spacer,
  student_requests: StudentRequests,
  supporto_assistenza: SupportoAssistenza,
  tabs_heading: TabsHeading,
  table: Table,
  tape: Tape
}
